const SupportTicketSkeleton = () => (
  <div className="support-ticket support-ticket__skeleton">
    <div className="support-ticket__wrapper">
      <div className="support-ticket__tag">
        <div className="support-ticket__skeleton-block"></div>
      </div>
      <div className="support-ticket__id">
        <div className="support-ticket__skeleton-block"></div>
      </div>
      <div className="support-ticket__meta">
        <div className="support-ticket__skeleton-block"></div>
      </div>
      <div className="support-ticket__subject">
        <div className="support-ticket__skeleton-block"></div>
      </div>
    </div>
  </div>
);

export default SupportTicketSkeleton;
